define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'jump'],
    function ($, transit, modernizr, container, preloader, jumpFactory) {


        return (function () {

            const name = 'module-program-tv';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const pubSub = container.getPublishSubscribe();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {

            };

            model.methods = {

            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                currentItem: 1,
                anim: false
            };

            view.startup = function () {

            };

            view.bind = function () {
                $(view.publicVars.cssId.programTvItemCls).click(function () {
                    const id = parseInt(container.getData($(this)[0], 'id'));
                    const hours = container.getData($(this)[0], 'hours');

                    if(id !== view.privateVars.currentItem && !view.privateVars.anim) {
                        view.privateVars.anim = true;
                        view.methods.openItem(id, hours);
                    }
                });

                $(window).resize(() => {
                    view.methods.handleItemsOnResize();
                });

                $(window).on('orientationchange', () => {
                    view.methods.handleItemsOnResize();
                });
            };

            view.methods = {
                openItem: (id, hours) => {
                    $(view.publicVars.cssId.programTvItemCls).removeClass(view.publicVars.cssId.isOpenedCls.substr(1));
                    $(view.publicVars.cssId.programTvItemCls + id).addClass(view.publicVars.cssId.isOpenedCls.substr(1));

                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();
                    let submenuHeight = $(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).outerHeight() -
                        parseInt($(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).css('bottom')) - 30;

                    if($(view.publicVars.cssId.headerSeriesSubmenuCls).css('display') === 'none') {
                        submenuHeight = 0;
                    }

                    jump.centerTo(view.publicVars.cssId.programTvDateHoursInnerCls, () => {
                        $(view.publicVars.cssId.programTvDateHoursInnerCls).transit({ opacity: 0}, 300, function () {
                            $(view.publicVars.cssId.programTvDateHoursInnerCls).html(hours);
                            $(view.publicVars.cssId.programTvDateHoursInnerCls).transit({ opacity: 1}, 300, function () {
                                view.privateVars.anim = 0;
                                view.privateVars.currentItem = id;
                            });
                        });
                    }, {
                        modifier: - parseInt(headerHeight + submenuHeight)
                    });

                },

                handleItemsOnResize: () => {
                    if($(window).width() < 600 && view.privateVars.currentItem > 4) {
                        const hours = container.getData($(view.publicVars.cssId.programTvItemCls + 1)[0], 'hours');

                        view.privateVars.anim = true;
                        view.methods.openItem(1, hours);
                    }
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowCharacter', view.methods.actionShowCharacter);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
